<template>
  <div id="subTitle">
    <div id="subTitleWrapper">
      <h2 id="subTitleText">{{subtitle}}</h2>
      <div id="description" v-if="description != null">{{dataDescription}}</div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const delay = this.description.length >= 10 ? 80 : 120;
    [...this.description].forEach((character, index) => {
      setTimeout(() => {
        this.dataDescription += character;
      }, delay * ++index);
    });
  },
  props: {
    subtitle: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: null
    }
  },
  data: () => ({
    dataDescription: ""
  })
};
</script>

<style scoped>
#subTitleWrapper {
  margin: 0;
  padding-top: 5px;
  padding-bottom: 10px;
  background-color: rgb(86, 136, 245, 0.3);
}

#subTitleText:before,
#subTitleText:after {
  content: "";
  display: inline-block;
  vertical-align: middle;
  width: 20%;
  animation: 1s ease-in 0s 1 alternate forwards slidein;
}

@keyframes slidein {
  from {
    background-color: rgb(0, 0, 0, 0.2);
    transform: scaleY(0);
    transform: scaleX(0);
    height: 0px;
  }
  to {
    background-color: rgb(86, 136, 245, 1);
    transform: scaleY(1);
    transform: scaleX(1);
    height: 4px;
  }
}

#subTitleText {
  font-weight: bolder;
  margin: 3% 10%;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: rgb(86, 136, 245, 0.4);
}

#description {
  font-size: 80%;
  margin-left: 20%;
  margin-right: 20%;
  padding-bottom: 3%;
}

#description::after {
  content: "";
  margin-left: 2px;
  border-right: 1px solid;
  animation: flashing 1s linear infinite;
}

@keyframes flashing {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>